import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
    SendOtpRequestDto,
    VerifyOtpRequestDto,
    ResendOtpRequestDto,
    OtpResponseDto,
    Msg91ResponseDto
} from '../models/sms.model';

@Injectable({
    providedIn: 'root'
})
export class SmsService {
    private apiUrl = `${environment.apiConfig.uri}/api/Sms`;

    constructor(private http: HttpClient) { }

    /**
     * Send OTP to a mobile number
     * @param request - Send OTP request with mobile number
     * @returns Observable of MSG91 response
     */
    sendOtp(request: SendOtpRequestDto): Observable<Msg91ResponseDto> {
        return this.http.post<Msg91ResponseDto>(`${this.apiUrl}/send-otp`, request);
    }

    /**
     * Verify OTP for a mobile number
     * @param request - Verify OTP request with mobile and OTP
     * @returns Observable of OTP response
     */
    verifyOtp(request: VerifyOtpRequestDto): Observable<OtpResponseDto> {
        return this.http.post<OtpResponseDto>(`${this.apiUrl}/verify-otp`, request);
    }

    /**
     * Resend OTP to a mobile number
     * @param request - Resend OTP request with mobile number
     * @returns Observable of OTP response
     */
    resendOtp(request: ResendOtpRequestDto): Observable<OtpResponseDto> {
        return this.http.post<OtpResponseDto>(`${this.apiUrl}/resend-otp`, request);
    }
}
